import { SEQUENCE_FLAG_LABELS } from '../../labels';

import type { SequenceFlag } from '../../view-models';
import type React from 'react';

export interface SequenceFlagBadgeProps {
  flag: SequenceFlag;
}

export function SequenceFlagBadge({ flag }: SequenceFlagBadgeProps): React.JSX.Element | null {
  const map: Record<SequenceFlag, { label: string; tone: string }> = {
    highVolume: { label: SEQUENCE_FLAG_LABELS.highVolume, tone: 'warning' },
    escalating: { label: SEQUENCE_FLAG_LABELS.escalating, tone: 'danger' },
    allAbandoned: { label: SEQUENCE_FLAG_LABELS.allAbandoned, tone: 'danger' },
    crossChannel: { label: SEQUENCE_FLAG_LABELS.crossChannel, tone: 'info' },
  };
  const m = map[flag];
  if (m === undefined) return null;
  return <span className={`seq-flag seq-flag--${m.tone}`}>{m.label}</span>;
}
